// extracted by mini-css-extract-plugin
module.exports = {"container":"talent-tooltip_container_2utk_"};